export const SANDBOX_BASE_URL = import.meta.env.VITE_SANDBOX_BASE_URL;
export const PARTNER_UPLOAD_ANON_DATA_URL = import.meta.env.VITE_PARTNER_UPLOAD_ANON_DATA_URL;
export const HOSTED_APPLICATION_SIMULATION_STATUS_URL = import.meta.env.VITE_HOSTED_APPLICATION_SIMULATION_STATUS_URL;
